// Creator fields the admin needs to know if a removal reaches the app, and to reach him otherwise.
export const CREATOR_FIELDS = `
  id
  avatar
  username
  email
  fcmPermissionStatus
  language
  timezone
  connectedAt
  connectedWith
  versionApple
  versionAndroid
`;
